/* RESPONSIBLE TEAM: team-phone */
import Model, { attr } from '@ember-data/model';
import type { FinVoiceVoice } from 'embercom/objects/ai-agent/fin-voice/fin-voice-voice-options';
export interface FinVoiceNumberConfigurationPredicates {
  percentageRollout?: number;
  officeHoursComparison?: 'in' | 'nin';
  officeHoursSchedule?: string;
}

export interface HandoverToVoicemailConfiguration {
  type: 'handover-to-voicemail';
  config: {
    assigneeId?: string;
  };
}

export interface HandoverToHumanConfiguration {
  type: 'handover-to-human';
  config: {
    assigneeId?: string;
    deflectionTimer?: number; // in seconds
  };
}

export type HandoverConfiguration = HandoverToVoicemailConfiguration | HandoverToHumanConfiguration;

export interface FinVoiceNumberConfigurationHandoverConfiguration {
  [key: string]: HandoverConfiguration;
}

export default class FinVoiceNumberConfiguration extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare workspacePhoneNumber: string;
  @attr() declare predicates: FinVoiceNumberConfigurationPredicates;
  @attr('string') declare voice: FinVoiceVoice;
  @attr('string') declare greeting: string;
  @attr() declare handoverConfiguration: FinVoiceNumberConfigurationHandoverConfiguration;
  @attr('string') declare status: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'fin-voice/number-configuration': FinVoiceNumberConfiguration;
  }
}
